<div class="ml-2 flex h-16 flex-row">
  <div
    *ngIf="!!fractionControl.label"
    class="text-s1 mr-5 flex h-9 flex-shrink-0 select-none items-center text-base"
    >{{ fractionControl.label }}</div
  >

  <div
    tp="Turn off formula to activate control"
    [tpIsEnabled]="isDisabled === true"
  >
    <div
      tp="The value can be set using the metrics time filter (at the top of this page)"
      [tpIsEnabled]="fractionControl.isMetricsDate === true"
    >
      <ng-select
        #fractionSelectorSelect
        [fixNgSelectBottom]="fractionSelectorSelect"
        data-cy="fractionSelectorSelect"
        class="popup-55 w-48"
        [ngClass]="{
          'cursor-default':
            isDisabled === true || fractionControl.isMetricsDate === true
        }"
        [items]="fractionControl.options"
        [clearable]="false"
        [searchable]="false"
        [disabled]="
          isDisabled === true || fractionControl.isMetricsDate === true
        "
        [(ngModel)]="fractionControl.value"
        (change)="valueChange($event)"
        (keyup.esc)="
          $event.stopImmediatePropagation(); fractionSelectorSelect.blur()
        "
        (keyup.enter)="
          $event.stopImmediatePropagation(); fractionSelectorSelect.blur()
        "
        appendTo="body"
        bindLabel="label"
        bindValue="value"
      >
        <ng-template ng-label-tmp let-item="item">
          <div class="ml-1 truncate">{{ item.label || item.value }}</div>
        </ng-template>

        <ng-template ng-option-tmp let-item="item">
          <div class="flex flex-row">
            <div class="ml-1 truncate">{{ item.label || item.value }}</div>
          </div>
        </ng-template>
      </ng-select>
    </div>
  </div>
</div>
